import { axiosPlatform } from "../../_services/axios-helper";

export const setupService = {
    determineShopifyPaymentProviders,
    getSetupStatus,
    prepareBillingActivation,
    prepareBillingActivationForClient,
    activateCharge,
    activateChargeForClient,
    deleteAccount,
};

function determineShopifyPaymentProviders(uuid) {
    return axiosPlatform().get("/setup/shopify/paymentproviders/" + uuid);
}

function getSetupStatus() {
    return axiosPlatform().get("/setup/status");
}

function prepareBillingActivation() {
    return axiosPlatform().post("/billing/shopify/activate", {});
}

function activateCharge(chargeId) {
    return axiosPlatform().post("/billing/shopify/activatecharge", { chargeId });
}

function prepareBillingActivationForClient(clientUUID) {
    return axiosPlatform().post("/billing/shopify/activate", { clientUUID });
}

function activateChargeForClient(chargeId, clientUUID) {
    return axiosPlatform().post("/billing/shopify/activatecharge", { chargeId, clientUUID });
}

function deleteAccount() {
    return axiosPlatform().get("/setup/deleteaccount");
}
